import { render, staticRenderFns } from "./MasterSatuan.vue?vue&type=template&id=623a4982&"
import script from "./MasterSatuan.vue?vue&type=script&lang=js&"
export * from "./MasterSatuan.vue?vue&type=script&lang=js&"
import style0 from "./MasterSatuan.vue?vue&type=style&index=0&id=623a4982&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports